import { useContext} from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserContext } from '../../hooks/UserContext';
import Loading from '../Loading';

function usePath() {
  const { pathname } = useLocation();
  // console.log(location)
  return pathname
  // return useMemo(() => new URLSearchParams(pathname), [pathname]);
}

export default function PRoute({children}) {
    const { user, isLoading } = useContext(UserContext);
    // console.log("PR user", { user, isLoading });
    const pathname = usePath()//.get("pathname")

    // PAGINA DE CARREGAMENTO (aguardando enquanto usuario é carregado)
    if(isLoading) {
        return (<Loading/>)
    }
    if(!!user){
        // SE USUARIO está autenticado: então carrega a página em component
        // return ( <Route {...rest} render={(props) => (<Component {...props}/>)}/>)
        return (children)
    } else {
        // SE USUARIO não está autenticado: então carrega a página de login
        return (<Navigate to= {!!pathname ? `/login?to=${pathname}`: '/login'}/>)
    }

}
